import { createTestIds } from '../../utils';

export const getHTMLTestIds = createTestIds('html', [] as const);
